<template>
  <div class="flex-row gaps-sm" v-if="isEditingThisAttachable">
    <a-input v-model="editedName" size="small" data-dusk="file-name-input"></a-input>
    <a-button @click="saveChanges" size="small" data-dusk="save-file-name">
      <content-save-icon></content-save-icon>
    </a-button>
  </div>
  <div v-else>
    <a-popover v-if="isMsgFile" placement="top">
      <template slot="content">
        <a :href="cellProps.show_link" target="_blank">
          Bestand bekijken
        </a>
        <br>
        <a :href="route('document.download', [cellProps.id])" target="_blank">
          Bestand downloaden
        </a>
      </template>
      <FileTypeIconComponent :filename="row.name"></FileTypeIconComponent>
      {{ row.name }}
    </a-popover>
    <a v-else :href="cellProps.show_link" class="flex-row align-items-center gap-xs" target="_blank">
      <FileTypeIconComponent :filename="row.name"></FileTypeIconComponent>
      {{ row.name }}
    </a>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import FileTypeIconComponent from '~/components/FileTypeIconComponent.vue';

export default {
  name: "FileNameCell",
  components: {
    FileTypeIconComponent,
  },
  props: {
    // Attachable Object
    row: {
      isEditing: Boolean,
      name: String,
    },
    cellProps: {
      show_link: String,
    }
  },
  data() {
    return {
      editedName: this.cellProps.name,
    }
  },
  computed: {
    ...mapState(`$_attachable_widget`, {
      editingAttachableWithId: 'editingAttachableWithId',
    }),
    isEditingThisAttachable() {
      return this.editingAttachableWithId === this.row.id;
    },
    isMsgFile() {
      return this.cellProps.extension === 'msg';
    },
  },
  methods: {
    ...mapActions(`$_attachable_widget`, {
      updateAttachableName: 'updateAttachableName',
    }),
    ...mapMutations(`$_attachable_widget`, {
      updateAttachableState: 'UPDATE_ATTACHABLE',
      setEditingAttachable: 'SET_EDITING_ATTACHABLE_WITH_ID'
    }),
    saveChanges() {
      this.row.name = this.editedName;
      this.updateAttachableName({id: this.row.id, name: this.row.name});
      this.updateAttachableState({attachable: this.row});
      this.setEditingAttachable(null);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
